export default {
  getItems(state, getters, rootState) {
    return rootState.rawData.data;
  },

  getActive(state) {
    return state.active;
  },
};
